import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "max-w-full overflow-auto [tab-size:2]" }
const _hoisted_2 = { class: "max-w-full overflow-auto [tab-size:2]" }
const _hoisted_3 = { class: "max-w-full overflow-auto [tab-size:2]" }

import { PropType } from 'vue';
import { QueryResult, RecordWithInfo } from '@/model/Api';


export default /*@__PURE__*/_defineComponent({
  __name: 'RawRecords',
  props: {
  records: {
    type: Object as PropType<QueryResult>,
    required: true,
  },
},
  setup(__props) {



function tabs(all: Array<RecordWithInfo>, current: RecordWithInfo, length: (r: RecordWithInfo) => number) {
  const maxWidth = Math.max(...all.map(length));
  const maxTabs = Math.floor(maxWidth / 2) + 1;
  const currentWidth = length(current);
  const currentTabs = maxTabs - Math.floor(currentWidth / 2);
  return '\t'.repeat(currentTabs);
}

function toName(record: RecordWithInfo) {
  return record.record.name.length;
}

function toTtl(record: RecordWithInfo) {
  return record.record.ttl.toString().length;
}

function toType(record: RecordWithInfo) {
  return record.record.recordType.length;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "block mt-3 uppercase font-medium text-neutral-600" }, "Question", -1)),
    _createElementVNode("pre", null, "dig @" + _toDisplayString(__props.records.query.server.domain || __props.records.query.server.ip) + " " + _toDisplayString(__props.records.query.domain) + " " + _toDisplayString(__props.records.query.recordType), 1),
    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "block mt-3 uppercase font-medium text-neutral-600" }, "Answer", -1)),
    _createElementVNode("pre", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.records.response.answer, (record, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          _createTextVNode(_toDisplayString(record.record.name) + _toDisplayString(tabs(__props.records.response.answer, record, toName)) + _toDisplayString(record.record.ttl) + _toDisplayString(tabs(__props.records.response.answer, record, toTtl)) + _toDisplayString(record.record.recordType) + _toDisplayString(tabs(__props.records.response.answer, record, toType)) + _toDisplayString(record.record.raw) + "\n", 1)
        ], 64))
      }), 128))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "block mt-3 uppercase font-medium text-neutral-600" }, "Authority", -1)),
    _createElementVNode("pre", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.records.response.authority, (record, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          _createTextVNode(_toDisplayString(record.record.name) + _toDisplayString(tabs(__props.records.response.authority, record, toName)) + _toDisplayString(record.record.ttl) + _toDisplayString(tabs(__props.records.response.authority, record, toTtl)) + _toDisplayString(record.record.recordType) + _toDisplayString(tabs(__props.records.response.authority, record, toType)) + _toDisplayString(record.record.raw) + "\n", 1)
        ], 64))
      }), 128))
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "block mt-3 uppercase font-medium text-neutral-600" }, "Additional", -1)),
    _createElementVNode("pre", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.records.response.additional, (record, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          _createTextVNode(_toDisplayString(record.record.name) + _toDisplayString(tabs(__props.records.response.additional, record, toName)) + _toDisplayString(record.record.ttl) + _toDisplayString(tabs(__props.records.response.additional, record, toTtl)) + _toDisplayString(record.record.recordType) + _toDisplayString(tabs(__props.records.response.additional, record, toType)) + _toDisplayString(record.record.raw) + "\n", 1)
        ], 64))
      }), 128))
    ])
  ], 64))
}
}

})